// Onboarding wizard store. URL is the source of truth for which step the user
// is on; this store mirrors it for cross-screen ephemeral state. Form drafts
// are intentionally NOT held here — each screen uses react-hook-form locally
// and persists via PATCH on submit.
import { create } from 'zustand';

export type OnboardingStep = 'mode' | 'goal' | 'body_stats' | 'activity' | 'training' | 'summary';

interface OnboardingActions {
  setCurrentStep(step: OnboardingStep): void;
  reset(): void;
}

interface OnboardingState {
  currentStep: OnboardingStep;
}

const INITIAL_STEP: OnboardingStep = 'mode';

export const useOnboardingStore = create<OnboardingState & OnboardingActions>((set) => ({
  currentStep: INITIAL_STEP,

  setCurrentStep(step) {
    set({ currentStep: step });
  },

  reset() {
    set({ currentStep: INITIAL_STEP });
  },
}));
